
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"id":"logoMark","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 14.147 19.45"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"id":"Path_24024","data-name":"Path 24024","d":"M8.777 170.393l-1.983.084v3.4H3.13l-.068-4.5-.108-.148h-.006a5.37 5.37 0 002.423 10.162h.459a5.37 5.37 0 005.37-5.371v-3.917c-.058-.007-.143-.3-.2-.305-.727-.026-1.443.593-2.221.592z","transform":"translate(0 -159.943)","fill":"#1ccdfd"}}),_c('path',{attrs:{"id":"Path_24025","data-name":"Path 24025","d":"M64.34 2.947A5.369 5.369 0 0059.549 0h-.459a5.37 5.37 0 00-5.37 5.371v3.916l.08.311a5.289 5.289 0 012.34-.8h1.8l-.007-3.426 3.943-.021-.015 4.611.115.2a5.37 5.37 0 002.364-7.215z","transform":"translate(-50.772)","fill":"#c458fb"}}),_c('path',{attrs:{"id":"logoMark_PathItem_3","d":"M57.874 96.66v3.406h-1.731a5.346 5.346 0 00-2.423.577v4.857h4.1v-3.4h1.731a5.347 5.347 0 002.423-.577V96.66z","transform":"translate(-50.772 -91.356)","fill":"#854cf9"}})])
          )
        }
      }
    